(() => {
const $98e37bbbd8091a40$var$lib = {
    selectors: {
        integrations: '.integrations',
        tile: '.tile',
        thumb: '.integrations__thumb'
    }
};
const $98e37bbbd8091a40$var$observer = new IntersectionObserver((entries)=>{
    entries.forEach((entry)=>{
        if (entry.isIntersecting) {
            // Loop through each tile in the integration container
            entry.target.querySelectorAll($98e37bbbd8091a40$var$lib.selectors.tile).forEach((tile)=>{
                const thumb = tile.querySelector($98e37bbbd8091a40$var$lib.selectors.thumb);
                // If the thumb has a data-src attribute, set the --src property to the value of the data-src attribute
                if (thumb && thumb.getAttribute('data-src')) {
                    thumb.style.setProperty('--src', `url(${thumb.getAttribute('data-src')})`);
                    thumb.removeAttribute('data-src');
                }
            });
            $98e37bbbd8091a40$var$observer.unobserve(entry.target);
        }
    });
});
document.querySelectorAll($98e37bbbd8091a40$var$lib.selectors.integrations).forEach((integrationContainer)=>{
    $98e37bbbd8091a40$var$observer.observe(integrationContainer);
});

})();
//# sourceMappingURL=integration.min.js.map
